module.exports = __webpack_public_path__ + "static/media/zikaronLogo.83eb74bb.svg";